<template>
    <div class="flex flex-wrap mt-3 items-center mb-3 country-box">
        <span v-if="notSupportedGeo" class="country-link not-supported">
            <img
                class="lazyload inline"
                :alt="geoName + ' Flag'"
                :src="geoFlag"
                :data-src="geoFlag"
                height="25"
                width="25"
            />
            <span
                class="ml-2 text-base leading-4 font-semibold"
            >{{ geoName }}</span>
        </span>
        <a v-else class="country-link" :href="geoPath">
            <img
                class="lazyload inline"
                :alt="geoName + ' Flag'"
                :src="geoFlag"
                :data-src="geoFlag"
                height="25"
                width="25"
            />
            <span
                class="ml-2 text-base leading-4 font-semibold"
            >{{ geoName }}</span>
        </a>
    </div>
</template>

<script>
export default {
    name: 'GeoLink',
    props: {
        geoData: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            geoPath: '#geo_link',
            geoName: 'Global',
            geoFlag: 'https://objects.kaxmedia.com/auto/o/133832/dc78f85d36.svg',
            supportedGeos: [],
            notSupportedGeo: true,
        };
    },
    mounted() {
        this.supportedGeos = JSON.parse(this.geoData);
        this.fetchCountryInformation();
    },
    methods: {
        visitorCountryCode() {
            if(!document.querySelector('html').dataset.ipcountry) {
                return 'gx';
            }

            return document.querySelector('html').dataset.ipcountry.toLowerCase();
        },

        fetchCountryInformation() {
            let visitorCountryCode = this.visitorCountryCode();

            let country = this.supportedGeos.find(function (country) {
                return country['code'].toLowerCase() === visitorCountryCode.toLowerCase();
            }, visitorCountryCode);

            if (country) {
                this.notSupportedGeo = false;
            }

            this.updateOptListCountry(country);
        },

        updateOptListCountry(country) {
            if (!this.notSupportedGeo) {
                this.geoName = country.name;
                this.geoFlag = country.flag_verified;
                this.geoPath = country.path;
            }
        },
    },
};
</script>
